"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileToDataURL = exports.createImage = exports.bufferArrToBase64 = exports.base64ToArray = void 0;
exports.getCroppedImg = getCroppedImg;
exports.getRadianAngle = getRadianAngle;
exports.isBase64String = void 0;
exports.rotateSize = rotateSize;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var isBase64String = exports.isBase64String = function isBase64String(str) {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};
var bufferArrToBase64 = exports.bufferArrToBase64 = function bufferArrToBase64(bufferArr) {
  if (isBase64String(bufferArr)) return bufferArr;
  var data = new Uint8Array(bufferArr);
  var binstr = Array.prototype.map.call(data, function (ch) {
    return String.fromCharCode(ch);
  }).join('');
  return btoa(binstr);
};
var fileToDataURL = exports.fileToDataURL = function fileToDataURL(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.onload = function (event) {
      resolve(event.target.result.split(',').pop());
    };
    reader.readAsDataURL(file);
  });
};
var base64ToArray = exports.base64ToArray = function base64ToArray(base64) {
  var binaryString = atob(base64);
  var len = binaryString.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};
var createImage = exports.createImage = function createImage(url) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.addEventListener('load', function () {
      return resolve(image);
    });
    image.addEventListener('error', function (error) {
      return reject(error);
    });
    image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });
};
function getRadianAngle(degreeValue) {
  return degreeValue * Math.PI / 180;
}

/**
 * Returns the new bounding area of a rotated rectangle.
 */
function rotateSize(width, height, rotation) {
  var rotRad = getRadianAngle(rotation);
  return {
    width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height)
  };
}
function getCroppedImg(_x, _x2) {
  return _getCroppedImg.apply(this, arguments);
}
function _getCroppedImg() {
  _getCroppedImg = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(imageSrc, pixelCrop) {
    var rotation,
      flip,
      image,
      canvas,
      ctx,
      rotRad,
      _rotateSize,
      bBoxWidth,
      bBoxHeight,
      data,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          rotation = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0;
          flip = _args.length > 3 && _args[3] !== undefined ? _args[3] : {
            horizontal: false,
            vertical: false
          };
          _context.next = 4;
          return createImage(imageSrc);
        case 4:
          image = _context.sent;
          canvas = document.createElement('canvas');
          ctx = canvas.getContext('2d');
          if (ctx) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", null);
        case 9:
          rotRad = getRadianAngle(rotation); // calculate bounding box of the rotated image
          _rotateSize = rotateSize(image.width, image.height, rotation), bBoxWidth = _rotateSize.width, bBoxHeight = _rotateSize.height; // set canvas size to match the bounding box
          canvas.width = bBoxWidth;
          canvas.height = bBoxHeight;

          // translate canvas context to a central location to allow rotating and flipping around the center
          ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
          ctx.rotate(rotRad);
          ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
          ctx.translate(-image.width / 2, -image.height / 2);

          // draw rotated image
          ctx.drawImage(image, 0, 0);

          // croppedAreaPixels values are bounding box relative
          // extract the cropped image using these values
          data = ctx.getImageData(pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height); // set canvas width to final desired crop size - this will clear existing context
          canvas.width = pixelCrop.width;
          canvas.height = pixelCrop.height;

          // paste generated rotate image at the top left corner
          ctx.putImageData(data, 0, 0);

          // As Base64 string
          // return canvas.toDataURL('image/jpeg');

          // As a blob
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            canvas.toBlob(function (file) {
              resolve(URL.createObjectURL(file));
            }, 'image/jpeg');
          }));
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getCroppedImg.apply(this, arguments);
}